import React, { forwardRef, useState } from 'react';
import { FaRegCopy } from 'react-icons/fa';
import useLocalization from '../../../hooks/useLocalization';
import AudioResponsePlayer from './BotResponseComponent/AudioResponsePlayer';
import PropTypes from "prop-types";



const UserChatHead = forwardRef(({
    message = {},
    timestamp,
    onCopy,
    userImage = 'https://via.placeholder.com/40',
    identificationClassName = '',
}, ref) => {
    const { text, image, audio } = message;
    const { t } = useLocalization();
    const [showText, setShowText] = useState(true);

    return (
        <div ref={ref} className={`relative flex flex-col items-end space-y-2 z-50 w-full max-w-2xl ml-auto ${identificationClassName}`}>
            <div className='mt-2'>
                <div className="flex flex-col sm:flex-row items-start justify-end space-x-3 sm:space-x-4 sm:space-y-0">
                    <div className="relative bg-gradient-to-b from-[#0F2FA0] via-[#0F2FA0] to-[#007E86] dark:bg-[#FFFDFC1A] text-[#fff] dark:text-[#FFFFFF] shadow-lg rounded-md p-4 max-w-[90vw] sm:max-w-[50vw] break-words space-y-2">
                        {image && (
                            <img
                                src={image}
                                alt="Sent content"
                                className="max-h-60 rounded-lg object-cover"
                            />
                        )}

                        {audio && (
                            <AudioResponsePlayer
                                contentAudio={audio}
                                isLoading={false}
                                t={t}
                                showText={showText}
                                setShowText={setShowText}
                            />
                        )}
                        {showText && text && (
                            <div className="text-sm">{text}</div>
                        )}
                        <div
                            className="absolute right-[-7px] top-5 -translate-y-1/2 translate-x-2 w-0 h-0 
                        border-t-[3px] border-t-transparent 
                        border-l-[15px] border-l-blue-900 
                        border-b-[12px] border-b-transparent"
                        ></div>
                    </div>
                    <img
                        src={userImage}
                        alt="User Avatar"
                        className="w-10 h-10 rounded-full object-cover border border-white dark:border-gray-600 hidden md:block"
                    />
                </div>
                <div className="flex space-x-2 text-sm text-gray-600 dark:text-gray-300 mt-2 justify-between">
                    <div className='flex space-x-2'>
                        <button onClick={onCopy} title="Copy message" className="hover:text-blue-500 transition-colors">
                            <FaRegCopy />
                        </button>
                    </div>

                    {timestamp && (
                        <div className="text-xs text-gray-500 dark:text-gray-400 text-right">
                            {timestamp}
                        </div>
                    )}
                </div>
            </div>


        </div>
    );
});
UserChatHead.propTypes = {
    message: PropTypes.shape({
        text: PropTypes.string,
        image: PropTypes.string,
        audio: PropTypes.string,
    }),
    timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onCopy: PropTypes.func,
    userImage: PropTypes.string,
    identificationClassName: PropTypes.string,
};

UserChatHead.displayName = "UserChatHead";
export default UserChatHead;
